import { toArabicIndicDigits } from './arabicDigits';

export const arabicNumeralsPostProcessor = {
  type: 'postProcessor',
  name: 'arabicNumerals',
  process(
    value: string,
    _key: string,
    _options: unknown,
    translator: { language?: string }
  ) {
    const language = translator?.language ?? '';
    if (!language.startsWith('ar')) return value;
    return toArabicIndicDigits(value);
  },
};
